import { gettext } from '@eventbrite/i18n';

/**  LOGIN API ERROR MESSAGES  **/
export const USER_EMAIL_INVALID_MESSAGE = gettext(
    'There is no account associated with the email.',
);

export const FORBIDDEN_MESSAGE = gettext('Your Account has been locked.');

export const USER_ACCOUNT_SUSPENDED_MESSAGE = gettext(
    'Your Account has been suspended.',
);

export const CREDENTIALS_MUST_CHANGE_MESSAGE = gettext(
    'This user’s password must change before logging in.',
);

export const DEFAULT_ERROR_MESSAGE = gettext(
    'Whoops! Someone must have pulled a plug somewhere... try again.',
);

export const CAPTCHA_REQUIRED_MESSAGE = gettext('Complete to proceed');
export const ACCESS_DENIED_MESSAGE = gettext('The password is not correct.');

export const VERIFICATION_REQUIRED_CHECKOUT_MESSAGE = gettext(
    "We don't recognize your login details.",
);
export const VERIFICATION_REQUIRED_CHECKOUT_EXTRA_MESSAGE = gettext(
    'Please continue as guest',
);

// User has no password different messages because it may be linked to social accounts
export const USER_HAS_NO_PASSWORD_MESSAGE = gettext('User has no password');
export const LOGIN_SOFT_ACCOUNT_MESSAGE = gettext(
    'We sent you an email to {email} with intructions to set your password.',
);

/**  FORM MESSAGES START **/

export const FORM_FIELD_REQUIRED = gettext('Field required');
export const FORM_FIELD_INVALID_EMAIL = gettext('Invalid email');
export const FORM_FIELD_COMPLETE_TO_PROCEED = gettext('Complete to proceed');

/**  FORM MESSAGES END **/
